// extracted by mini-css-extract-plugin
export var clauseRow = "_fb-6";
export var emptyState = "_fb-d";
export var filterContent = "_fb-a";
export var filterGroup = "_fb-1";
export var filterGroupContainer = "_fb-0";
export var nestedGroup = "_fb-2";
export var nestedGroupContent = "_fb-b";
export var nestedGroupDepth1 = "_fb-3";
export var nestedGroupDepth2 = "_fb-4";
export var nestedGroupDepth3 = "_fb-5";
export var nestedGroupEmpty = "_fb-c";
export var operatorAnd = "_fb-8";
export var operatorOr = "_fb-9";
export var operatorToggle = "_fb-7";
export var removeGroupButton = "_fb-e";